/**
 * theme.context.ts
 * React context + hook for the landlord theme preference.
 * Exported separately to satisfy the react-refresh/only-export-components rule.
 */

import { createContext, useContext } from 'react';
import type { ResolvedTheme, ThemePreference } from '@/lib/theme';

export interface ThemeContextValue {
  preference: ThemePreference;
  resolved: ResolvedTheme;
  systemTheme: ResolvedTheme;
  setPreference(p: ThemePreference): void;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return ctx;
}
